<template>
  <div>
    <template v-if="subscriptionStatus">
      <AppDialog
        v-model="dialog"
        max-width="1178"
      >
        <template v-slot:activator="{ on, attrs }">
          <slot name="button" v-bind="{on, attrs}">
            <button
              v-bind="attrs"
              v-on="on"
              class="dashboard-payment-btn"
            >
              {{ $t('cancelSubscription') }}
            </button>
          </slot>
        </template>
        <VCard class="subscription-cancel">
          <div class="subscription-cancel__title">
            <div class="subscription-cancel__icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.35 1H13.65L1 13.65V34.35L13.65 47H34.35L47 34.35V13.65L34.35 1Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M23.9998 30.9C22.0448 30.9 20.5498 32.395 20.5498 34.35C20.5498 36.305 22.0448 37.8 23.9998 37.8C25.9548 37.8 27.4498 36.305 27.4498 34.35C27.4498 32.395 25.9548 30.9 23.9998 30.9Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.0002 26.3C25.2652 26.3 26.0702 25.61 26.3002 24.575C26.5302 23.54 27.2202 16.41 27.4502 12.615C27.5652 10.545 25.9552 9.04999 24.0002 9.04999C22.0452 9.04999 20.4352 10.545 20.5502 12.615C20.7802 16.41 21.4702 23.54 21.7002 24.575C21.9302 25.61 22.7352 26.3 24.0002 26.3Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <slot name="title">
              {{ $t('subscriptionCancelDialogTitle') }}
            </slot>
          </div>
          <div class="subscription-cancel__text">
            <div class="mb-2">
              <slot name="paidFor">
                {{ $t('subscriptionCancelDialog') }}
              </slot>
              <span class="d-block d-sm-inline">{{ $t('subscriptionCancelDialogDate', { date: expirationText }) }} </span>
            </div>
            <slot name="text">
              {{ $t('subscriptionCancelDialog2') }}
            </slot>
          </div>
          <div class="subscription-cancel__btn-wrap">
            <button
              class="subscription-cancel__btn subscription-cancel__btn_cancel"
              @click="dialog = cancelSubscriptionDialog()"
            >
              <slot name="btnName">
                {{ $t('cancelSubscription') }}
              </slot>
            </button>
            <button
              class="subscription-cancel__btn"
              @click="dialog = false"
            >
              {{ $t('cancel') }}
            </button>
          </div>
        </VCard>
      </AppDialog>
    </template>
  </div>
</template>

<script>
import useSubscription from '@/compositions/accounting/useSubscription';
import useAccount from '@/compositions/accounting/useAccount';
import AppDialog from '@/components/AppDialog';

export default {
  name: 'CancelSubscription',
  components: { AppDialog },
  setup() {
    const {
      cancelSubscription, subscriptionStatus,
    } = useSubscription();
    const {
      expirationText,
    } = useAccount();
    function cancelSubscriptionDialog() {
      cancelSubscription();
      return false;
    }

    return {
      subscriptionStatus,
      expirationText,
      cancelSubscriptionDialog,
    };
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.dashboard-payment-btn {
  display: block;
  font-size: 0.875rem;
  padding: 0.4375rem 1.125rem;
  border: 1px solid #D6D6D6;
  border-radius: 0.25rem;
  margin-left: auto;
}
.subscription-cancel {
  padding: 2.125rem 1.25rem 3.125rem;
  text-align: center;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 8.25rem;
    height: 8.25rem;
    background: #FF0000;
    border: 1rem solid #ffe6e6;
    border-radius: 50%;
    margin: 0 auto 1.25rem auto;
  }
  &__title {
    font-size: 2.125rem;
    font-weight: 400;
    line-height: 1.32;
    color: #091A35;
    margin-bottom: 0.625rem;
  }
  &__text {
    width: 100%;
    max-width: 45rem;
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.53;
    color: #091A35;
    margin: 0 auto 2.5rem auto;
  }
  &__btn {
    display: inline-block;
    padding: 1rem 1.25rem;
    border: 1px solid #D6D6D6;
    line-height: 1.15;
    font-weight: 400;
    letter-spacing: 0.02em;
    border-radius: 0.25rem;
    margin-right: 1.25rem;
    &_cancel {
      background-color: #FFFFFF;
      color: #EA0D0D;
      border-color: #EA0D0D;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .dashboard-payment-btn {
    margin: 0 auto;
  }
  .subscription-cancel {
    &__icon {
      width: 6.875rem;
      height: 6.875rem;
      border-width: 0.83rem;
      svg {
        padding: 0.25rem;
      }
    }
    &__title {
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.1;
      margin-bottom: 1.125rem;
    }
    &__text {
      max-width: 25rem;
      font-size: 1rem;
    }
    &__btn {
      padding: 0.875rem 1.25rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .dashboard-payment-btn {
    font-size: 0.8125rem;
  }
  .subscription-cancel {
    padding: 1.875rem 1.125rem 2rem;
    &__icon {
      width: 5.5rem;
      height: 5.5rem;
      border-width: 0.67rem;
      svg {
        padding: 0.5rem;
      }
    }
    &__title {
      font-size: 1.375rem;
      font-weight: 500;
      line-height: 1.1;
      margin-bottom: 1rem;
    }
    &__text {
      max-width: 18.5rem;
      font-size: 0.9375rem;
      margin: 0 auto 1.5rem;
    }
    &__btn {
      display: block;
      margin: 0 auto 1.25rem auto;
      &:last-child {
        margin-right: auto;
        margin-bottom: 0;
      }
    }
  }
}

</style>

<i18n lang="yml" locale="ru">
cancel: Отмена
cancelSubscription: Отменить подписку
subscriptionCancelDialog: Ваша подписка оплачена
subscriptionCancelDialogDate: до {date}.
subscriptionCancelDialog2: 'Если вы отмените подписку сегодня, то сможете пользоваться сервисом до указанной даты. Счёт за следующий период выставлен не будет.'
subscriptionCancelDialogTitle: Отмена подписки
</i18n>
<i18n lang="yml" locale="en">
cancel: Cancel
cancelSubscription: Cancel subscription
subscriptionCancelDialog: Your subscription is paid
subscriptionCancelDialogDate: until {date}.
subscriptionCancelDialog2: 'If you cancel your subscription today, you will be able to use the service until that date. You will not be billed for the next period.'
subscriptionCancelDialogTitle: Subscription cancellation
</i18n>
